/* eslint-disable react/no-array-index-key */
import {Typography, css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';
import {EntityLink} from 'src/js/containers/file';

import {HaidiHaiTypeFormatter} from './HaidiHaiTypeFormatter';
import {HaidiSchema} from '../../types';
import {Formatters} from '../light';
import {AG_GRID_COMPATIBILITY} from '../LightTable';
import {TooltipWrapper} from '../TooltipWrapper';

interface OwnProps {
  encounterId: string;
  data: HaidiSchema.components['schemas']['EncounterTimelineEventDto'];
  formatters: Formatters;
}

type Props = OwnProps;

export const EncounterTimelineAnnotationFormatter: React.FC<Props> = ({encounterId, data, formatters}) => {
  const theme = useTheme();
  const styles = getStyles({theme, params: {}});
  const {t} = formatters;
  return (
    <>
      <div css={styles.annotationWrapper}>
        {(data.annotations ?? []).map((v, i) => {
          const route = v.documentVersionId ? `/encounter/${encounterId}/document/${v.documentVersionId}` : '';
          const searchParams = {};
          const defaultAnnotation = data.eventType === 'SURGERY' ? t('encounter.timelineTable.annotation.missingSurgeryProtocol') : '';
          const annotation = v.annotation || defaultAnnotation;
          const annotationTooltip = v.annotationTooltip || annotation;
          // the wrapper below already carries the richer tooltip (backend annotationTooltip: the full
          // microbiology text incl. ATB susceptibilities) — noTooltip keeps the chip from opening its
          // own popper on the same hover, which only repeated the annotation text.
          return (
            <TooltipWrapper key={i} tooltip={annotationTooltip} maxWidth={300} noPadding>
              {route ? (
                <EntityLink route={route} searchParams={searchParams} inputCss={styles.link} suppressPadding>
                  <HaidiHaiTypeFormatter
                    {...AG_GRID_COMPATIBILITY}
                    value={annotation}
                    data={{type: v?.haiType}}
                    underlined
                    noWrap
                    noTranslate
                    noTooltip
                  />
                </EntityLink>
              ) : (
                <Typography variant='value' css={styles.text}>
                  {annotation}
                </Typography>
              )}
            </TooltipWrapper>
          );
        })}
      </div>
    </>
  );
};

EncounterTimelineAnnotationFormatter.displayName = 'EncounterTimelineAnnotationFormatter';

export const TIMELINE_ANNOTATION_GAP = '2px';
const getStyles: GetStylesFunction = (options) => ({
  annotationWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${TIMELINE_ANNOTATION_GAP};
    min-width: 50px;
  `,
  link: css`
    max-width: 100%;
  `,
  text: css`
    padding-left: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    max-width: 100%;
  `,
});
